
import axios from 'axios';
import JWT from 'jwt-simple';
import {apiUrl,PSJSC} from './Variables';

const BaseURL = apiUrl;

function buildUrl(type, withIndex = false){
	let base = BaseURL;
	if(withIndex && base.indexOf('/index.php/') === -1){
		base = base.replace(/\/$/, '') + '/index.php/';
	}
	return base + type;
}

export function GetData(type, userData) {

	return new Promise((resolve, reject) =>{
		fetch(buildUrl(type, false), {
			method: 'GET',
			body: JSON.stringify(userData)
		})
		.then((response) => response.json())
		.then((res) => {
			resolve(res);
		})
		.catch((error) => {
			fetch(buildUrl(type, true), {
				method: 'GET',
				body: JSON.stringify(userData)
			})
			.then((response) => response.json())
			.then((res) => resolve(res))
			.catch((e2) => reject(e2 || error));
		});
	});
}

export function PostData(type, userData) {
	
	return new Promise((resolve, reject) =>{
		fetch(buildUrl(type, false), {
			method: 'POST',
			body: JSON.stringify(userData)
		})
		.then((response) => response.json())
		.then((res) => {
			resolve(res);
		})
		.catch((error) => {
			fetch(buildUrl(type, true), {
				method: 'POST',
				body: JSON.stringify(userData)
			})
			.then((response) => response.json())
			.then((res) => resolve(res))
			.catch((e2) => reject(e2 || error));
		});
	});
}

export function axGet(type){
	
	return new Promise((resolve, reject) =>{
		axios.get(buildUrl(type, false), {
			method: 'GET'
		})
		.then((response) =>  {
			resolve(response);
		})
		.catch((error) => {
			if(error && error.response && error.response.status === 404){
				axios.get(buildUrl(type, true), {
					method: 'GET'
				})
				.then((response) => resolve(response))
				.catch((e2) => reject(e2 || error));
			}
			else{
				reject(error);
			}
		});
	});

}

export function axPost(type,userData){
	
		
	//if(navigator.onLine){
		
		return new Promise((resolve, reject) =>{
			axios.post(buildUrl(type, false),userData).then((response) =>  {
				resolve(response);
			})
			.catch((error) => {
				if(error && error.response && error.response.status === 404){
					axios.post(buildUrl(type, true),userData).then((response) =>  {
						resolve(response);
					})
					.catch((e2) => {
						reject(e2 || error);
					});
				}
				else{
					reject(error);
				}
			});
		});
		
	//}
}


export function Token(data){
	var token = JWT.encode(data, PSJSC);
	return token;
}

export function TokenData(data){
	var token = JWT.decode(data, PSJSC);
	return token;
}

export function getTokenData(fieldName,fromData='own'){
	
	var data = localStorage.getItem('dbs_retailer_data');
	
	if( fromData=='wl' ) data = localStorage.getItem('dbs_retailer_wldata');
	
	if(!data) return false;
	
	let s = JWT.decode(data, PSJSC);
	
	if(Object.keys(s).length>0)
	{
		return (s[fieldName]) ? s[fieldName] : false;
	}
	else
	{
		return false;
	}
}

export function TimeStamp(){
	var date = new Date();
	var timestamp = [];
	timestamp[0] = date.getTime();
	var token = JWT.encode(timestamp, PSJSC);
	return token;
}